<template>
<transition name="el-message-fade"  @enter="handleEnter" @leave="handleLeave" appear>
 <!-- <div class="yjui-message  yj-message-success el-message-fade-leave-active el-message-fade-leave-to"> -->
  <div :class="classes"  v-show="isClose">
    <i class="yjui-message-icon" :class="iconType"></i>
    <p class="yjui-message-content">{{message}}</p>
    <!-- <i class="el-message__closeBtn el-icon-close"></i> -->
  </div>
</transition>
</template>
<script>
    export default {
        props: {
            duration: {
                type: Number,
                default: 1.5
            },
            type: {
                type: String
            },
            message: {
                type: String,
                default: ''
            },
            msgType: {
                type: String
            },
            iconType: {
                type: String
            }
            
        },
        data () {
            return {
                closeTimer:null,
                isClose:true
            };
        },
        computed: {
            classes () {
                return [
                    {
                        [`yjui-message`]: true,
                        [`yj-message-${this.msgType}`]: this.msgType
                    }
                ];
            },
        },
        methods: {
            close () {
               this.isClose=false;
                setTimeout(function() {
                    document.body.removeChild(document.getElementsByClassName("yjui-message")[0]);
                 }, 500);
                
            },
            clearCloseTimer () {
              if (this.closeTimer) {
                  clearTimeout(this.closeTimer);
                  this.closeTimer = null;
              }
            },
            handleEnter (el) {
                //el.style.height = el.scrollHeight + 'px';
            },
            handleLeave (el) {
                  // el.style.height = 0;
                  //       el.style.paddingTop = 0;
                  //       el.style.paddingBottom = 0;
            }
          
        },
      mounted () {
            this.clearCloseTimer();
            if (this.duration !== 0) {
                this.closeTimer = setTimeout(() => {
                    this.close();
                }, (this.duration * 1000));
            }
  
        },
        beforeDestroy () {
            this.clearCloseTimer();
        }
    };
</script>
<style scoped>
.yjui-message {  box-sizing: border-box;   border-radius: 4px; border: 1px solid #ebeef5; position: fixed; left: 50%; top: 40%; transform: translateX(-50%); background-color: #edf2fc; transition: opacity .3s,transform .4s; overflow: hidden; padding: 15px; display: flex; align-items: center; z-index: 100000; }
.yjui-messag p { margin: 0 }
.yjui-message-icon { margin-right: 10px; font-size: 1.8rem; }
.yj-message-info .yjui-message-content,.yj-message-info .yjui-message-icon { color: #909399; font-size: 1.4rem; }

.yj-message-success { background-color: #f0f9eb; border-color: #e1f3d8 }
.yj-message-success .yjui-message-content,.yj-message-success .yjui-message-icon { color: #67c23a }
.yj-message-warning { background-color: #fdf6ec; border-color: #faecd8 }
.yj-message-warning .yjui-message-content ,.yj-message-warning .yjui-message-icon { color: #e6a23c }
.yj-message-error { background-color: #fef0f0; border-color: #fde2e2 }
.yj-message-error .yjui-message-content ,.yj-message-error .yjui-message-icon { color: #f56c6c }
.yjui-message-content{padding: 0; font-size: 14px; line-height: 1 }




/* 关闭 */
.el-message-fade-leave{opacity: 1; }
.el-message-fade-leave-to{opacity: 0;transform: translate(-50%,-100%);}
/* 显示 */
.el-message-fade-enter {  opacity: 0;  transform: translate(-50%,-100%); }
.el-message-fade-enter-to{ opacity: 1; }

</style>



// WEBPACK FOOTER //
// src/components/Message/Message.vue